/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import React from 'react';
import PropTypes from 'prop-types';
import 'src/components/BoxPopularCategories.scss';
import icons from './BoxPopularCategoriesIcons';


const BoxPopularCategories = ({
  badge, iconName, title, counter, link
}) => {
  const copy = `${counter} oferty`;
  const Icon = icons[iconName];
  return (
    <a data-test="seo-box-categories-tile" href={ link } styleName="box-popular" title={ title }>
      {badge && <div styleName="box-popular__badge">{ badge }</div>}
      <div styleName="box-popular__icon-wrap">
        <Icon styleName="box-icon" />
      </div>
      <div styleName="box-popular__content-wrap box-content">
        <h4 styleName="box-content__title">{ title }</h4>
        <span styleName="box-content__counter">
          { copy }
        </span>
      </div>
    </a>
  );
};


BoxPopularCategories.propTypes = {
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  counter: PropTypes.number.isRequired,
  iconName: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default BoxPopularCategories;
